import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublicShippingMethodDataSourceService } from '../../services/public-shipping-method-data-source.service';
import { PublicShippingMethod } from '@web/shared/module/shop';
import { map, Observable } from 'rxjs';
import {
  PrimengDividerDirective,
  SpinnerFilledComponent,
} from '@web/shared/ui';
import { Divider } from 'primeng/divider';
import { SummernoteHtmlPreviewComponent } from '@web/shared/external';

@Component({
  selector: 'app-public-shipping-methods',
  imports: [
    CommonModule,
    SpinnerFilledComponent,
    Divider,
    PrimengDividerDirective,
    SummernoteHtmlPreviewComponent,
  ],
  templateUrl: './public-shipping-methods.component.html',
  styleUrl: './public-shipping-methods.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicShippingMethodsComponent {
  /* prettier-ignore */
  private readonly shippingMethodDataSource = inject(PublicShippingMethodDataSourceService);

  protected readonly categories$ = this.categoriesDataSource();

  protected categoriesDataSource(): Observable<
    Array<{ category: string; items: PublicShippingMethod[] }>
  > {
    return this.shippingMethodDataSource.fetchShippingMethods().pipe(
      map((methods) => {
        const categories = new Set(methods.map((method) => method.category));

        return Array.from(categories).map((category) => ({
          category,
          items: methods.filter((method) => method.category === category),
        }));
      }),
    );
  }
}
